import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';

import { taxSettingsIndex } from '../../redux/actions/taxSettings';

const TaxSettings = ({ payload, settings, submitSettings, loadTaxSettings, taxSettings, setShowNewTaxSettingModal, setActiveTaxSetting, setShowEditTaxSettingModal, setShowDisableTaxSettingModal }) => {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    loadTaxSettings(payload);
  }, []);

  const edit = (id) => {
    let taxSetting = taxSettings.taxSettings.find(taxSetting => taxSetting.id === id);
    setActiveTaxSetting(taxSetting);
    setShowEditTaxSettingModal(true);
  }

  const disable = (id) => {
    let taxSetting = taxSettings.taxSettings.find(taxSetting => taxSetting.id === id);
    setActiveTaxSetting(taxSetting);
    setShowDisableTaxSettingModal(true);
  }

  return(
    <div className="named-area">
      <div className="named-area__header">
        <div className="named-area__titles">
          <div className="named-area__title">Tax Settings</div>
        </div>
        <div className="named-area__description">
          
        </div>
      </div>
      <div className="named-area__body">
        <div className="a-card-stack">
          <div className="a-card__paddings">
            { taxSettings.status !== 'success' &&
              <div className="a-card a-card--normal">
                <div className="a-card__paddings">
                  <LoadingSpinner statusText="Loading Tax Settings"/>
                </div>
              </div>
            }


            { taxSettings.status === 'success' && taxSettings.taxSettings.length > 0 &&
            <div className="a-card a-card--normal">
              <div className="a-card__paddings">
                <div className="flex-table">
                  <div className="flex-table__head">
                    <div className="flex-table__col flex-table__col--align-left">Name</div>
                    <div className="flex-table__col flex-table__col--align-left">Rate</div>
                    <div className="flex-table__col flex-table__col--align-left">Code</div>
                    <div className="flex-table__col flex-table__col--align-right">Actions</div>
                  </div>

                  { taxSettings.taxSettings.map(taxSetting => 
                      <div className="flex-table__row">
                        <div className="flex-table__col flex-table__col--align-left">{taxSetting.tax_name}</div>
                        <div className="flex-table__col flex-table__col--align-left">{taxSetting.rate}</div>
                        <div className="flex-table__col flex-table__col--align-left">{taxSetting.code}</div>
                        <div className="flex-table__col flex-table__col--align-right">
                          <button className="btn btn-default" onClick={() => edit(taxSetting.id)}>
                            <span className="svg-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                            </span>
                            <span className="gwt-InlineLabel">Edit</span>
                          </button>
                          <button className="btn btn-default btn--destructive" onClick={() => disable(taxSetting.id)}>
                            <span className="svg-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0Zm-4.27 4.7a6 6 0 0 1-8.796-7.916l8.795 7.917Zm1.337-1.486L5.272 4.298a6 6 0 0 1 8.795 7.916Z"/></svg>
                            </span>
                            <span className="gwt-InlineLabel">Disable</span>
                          </button>
                        </div>
                      </div>
                    )
                  }

                </div>

                <button
                  className="btn btn-primary-accent"
                  onClick={() => setShowNewTaxSettingModal(true)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">New Tax Setting</span>
                </button>
              </div>
            </div>
          }
          { taxSettings.status === 'success' && taxSettings.taxSettings.length === 0 &&
            <div className="a-card a-card--normal a-card--warning">
              <div className="a-card__paddings">
                <div className="text-center">
                  <p>No tax settings set. Create tax settings to see them here.</p>
                  <button
                    className="btn btn-primary-accent"
                    onClick={() => setShowNewTaxSettingModal(true)}
                  >
                    <span className="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                    </span>
                    <span className="gwt-InlineLabel">New Tax Setting</span>
                  </button>
                </div>
              </div>
            </div>
          }


          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  settings: state.settings.settings,
  taxSettings: state.taxSettings,
});

const mapDispatchToProps = (dispatch) => ({
  submitSettings: (payload, newSettings) => dispatch(updateSettings(payload, newSettings)),
  loadTaxSettings: (payload) => dispatch(taxSettingsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxSettings);